import { useEffect } from "react";
import app from "nystem";

const DatabaseAdProps = ({ view, model }) => {
  useEffect(() => {
    const { field, eventType, listen } = model;

    const viewByType = {
      view,
      baseView: view.baseView,
      baseViewBaseView: view.baseView?.baseView,
      baseViewBaseViewBaseView: view.baseView?.baseView?.baseView,
    };
    const atVew = viewByType[eventType || "baseView"];
    const onChange = ({ id }) => {
      if (listen && !listen.includes(id)) return;
      setTimeout(() => {
        view.event("setSearch");
      }, 0);
    };
    atVew.on("change", -100, onChange);

    const onSearch = async (search) => {
      return {
        ...search,
        [field]: true,
        value: atVew.getValue(),
      };
    };

    view.on("setSearch", 100, onSearch);
    if (model.sendUpdateSearch) view.event("setSearch");
    return () => {
      view.off("setSearch", onSearch);
      if (model.sendUpdateSearch) view.event("setSearch");
    };
  }, [view, model]);

  return null;
};

export default DatabaseAdProps;
